




































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import NumberTmpl from "@/ui-component/number.vue";
import jsonURL from "@/shared/urls";
import moment from "moment/moment";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class ResumeEvent extends mixins(MyMixin) {
  @Prop() public selectedDay!: any;
  public dataGetted = false;
  public historique = { week: 0, month: 0, year: 0 };
  public datesStr = { week: "", month: "", year: "" };

  public close() {
    this.$emit("close");
  }
  /**
   * reload on change
   */
  @Watch("selectedDay", { immediate: true, deep: true })
  public onEvtChanged({ value, oldValue }: { value: any; oldValue: any }) {
    this.dataGetted = false;
    console.log(this.selectedDay);
    this.getHisto();
    this.dataGetted = true;
  }

  public updateDate(ev: any) {
    // this.$emit("changeDate", ev);
  }

  private getHisto() {
    const url = jsonURL.updateCAHTSurJour;

    const dates = {
      lastWeek: moment(this.selectedDay.date)
        .subtract(7, "day")
        .format("YYYY-MM-DD"),
      lastMonth: this.getSameDayLastMonth(this.selectedDay.date).format(
        "YYYY-MM-DD"
      ),
      lastYear: this.getSameDayLastYear(this.selectedDay.date).format(
        "YYYY-MM-DD"
      ),
    };
    this.datesStr.week = moment(dates.lastWeek).format("ddd DD MMM YY");
    this.datesStr.month = moment(dates.lastMonth).format("ddd DD MMM YY");
    this.datesStr.year = moment(dates.lastYear).format("ddd DD MMM YY");

    this.$store
      .dispatch("home/getHomeDataSimple", {
        WS: url,
        site: this.sites[0].restaurantId,
        date: dates.lastWeek,
      })
      .then((dataWeek: any) => {
        this.historique.week = dataWeek;
        this.$store
          .dispatch("home/getHomeDataSimple", {
            WS: url,
            site: this.sites[0].restaurantId,
            date: dates.lastMonth,
          })
          .then((dataMonth: any) => {
            this.historique.month = dataMonth;
            this.$store
              .dispatch("home/getHomeDataSimple", {
                WS: url,
                site: this.sites[0].restaurantId,
                date: dates.lastYear,
              })
              .then((dataYear: any) => {
                this.historique.year = dataYear;
              });
          });
      });
  }

  get sites(): any[] {
    return this.$store.getters["login/sites"];
  }
}
